/*============================================================================
"Add to cart" animation when bundle added to cart
==============================================================================*/

(function() {
  // Configuration
  const CONFIG = {
    selectors: {
      bundleButtons: ".bogos-bundles-quantity-break-button-add, .bogos-bundles-button-add"
    },
    delays: {
      initialDelay: 1250,  // Initial delay to let bundle app process
      cartFetchDelay: 250  // Delay before fetching cart data
    },
    maxAttempts: 3,
    retryDelay: 500
  };
  
  // Initialize the cart update handler
  function initCartUpdateHandler() {
    // Use event delegation for better reliability with dynamically added buttons
    document.addEventListener("click", function(event) {
      const button = event.target.closest(CONFIG.selectors.bundleButtons);
      if (!button) return;
      
      handleBundleAddToCart();
    });
  }
  
  // Handle bundle add to cart with retry logic
  function handleBundleAddToCart() {
    let attempts = 0;
    
    // Function to check cart and update UI
    const updateCart = async () => {
      try {
        // First open drawer
        document.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { open: true }
          })
        );
        
        // Get latest cart data with a small delay
        setTimeout(async () => {
          try {
            // Fetch cart data
            const response = await fetch(
              window.FoxTheme?.routes?.cart_url || "/cart.js", 
              window.FoxTheme?.utils?.fetchConfig() || { 
                method: "GET",
                credentials: "same-origin"
              }
            );
            
            if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
            
            const cartData = await response.json();
            
            // If cart is still empty and we haven't maxed out attempts, try again
            if (cartData.item_count === 0 && attempts < CONFIG.maxAttempts) {
              attempts++;
              setTimeout(updateCart, CONFIG.retryDelay);
              return;
            }
            
            // Update cart state if FoxTheme is available
            if (window.FoxTheme?.pubsub) {
              window.FoxTheme.pubsub.publish(
                window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
                { cart: cartData }
              );
            }
            
            // Dispatch a custom event for other scripts to hook into
            document.dispatchEvent(
              new CustomEvent("bundle:added-to-cart", { 
                bubbles: true,
                detail: { cart: cartData }
              })
            );
          } catch (error) {
            console.error("Error fetching cart data:", error);
          }
        }, CONFIG.delays.cartFetchDelay);
      } catch (error) {
        console.error("Error updating cart:", error);
      }
    };
    
    // Initial delay to let bundle app process
    setTimeout(updateCart, CONFIG.delays.initialDelay);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartUpdateHandler);
  } else {
    initCartUpdateHandler();
  }
})(); 